// OneDrive:IgnoreCodeCoverage

export * from '@ms/telemetry-manager/lib/events/Qos.event';
export { Qos as default } from '@ms/telemetry-manager/lib/events/Qos.event';
